/* eslint-disable */
import React, { useEffect, createContext, useContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Divider, Layout, Menu, Spin, Typography, Tag } from 'antd';
import axios from 'axios';
import { AuthContext, NavBarContext, AuthInfoContext, ConfigContext } from '../App';

const { Title, Text, Paragraph } = Typography;
function Home() {
  const navigate = useNavigate();
  const {isAuthenticated, setIsAuthenticated, authFailReason, setAuthFailReason, verifyAuth} = useContext(AuthContext);
  const {toggleNavBarVisibility, setSelectedKey, selectedKey} = useContext(NavBarContext);
  const { authInfo, setAuthInfo } = useContext(AuthInfoContext);
  const { appConfig } = useContext(ConfigContext);

  useEffect(() => {
    verifyAuth();
    setSelectedKey('1');
    toggleNavBarVisibility(true);
    return () => {
      toggleNavBarVisibility(true);
    };
  }, []);
  return (
    <div style={{ display: 'flex', alignItems: 'left', justifyContent: 'left', height: '100%' }}>
      <div style={{ textAlign: 'left', width: '90%' }}>
        <Title level={1} style={{ marginTop: '0em' }}>Welcome to SteadyShuttle.</Title>
        {/* KL beta banner removed; title below carries beta branding */}
        <Title level={5}>Use the navigation bar on the top to access the different modules.</Title>
        <Divider/>
        { (appConfig['kl-enabled']) && (
          <>
            <Title level={3}>Introducing SteadyShuttle KL <Tag color="green" style={{ verticalAlign: 'middle' }}>Beta</Tag></Title>
            <Paragraph>
              We are piloting ETS bookings for the route <b>JB SENTRAL</b> → <b>KL SENTRAL</b>.
            </Paragraph>
            <Paragraph>
              At the moment, only <b>Platinum</b> class trains are available for this route.
            </Paragraph>
            <Divider/>
          </>
        )}
        <Title level={3}>Get started with these steps.</Title>
        <Paragraph>1. Create a passenger.</Paragraph>
        <Paragraph>2. Create a booking for specified passenger.</Paragraph>
        <Paragraph>3. Wait for approval (you'll receive a notification)</Paragraph>
        <Paragraph>4. Make payment for booking (only PayNow accepted)</Paragraph>
        <Paragraph>5. Wait for booking to be processed.</Paragraph>
        <Paragraph>6. Receive confirmation via Telegram.</Paragraph>
        <Paragraph>[!] Unsuccessful booking? Refunds will be processed automatically within an hour from the departure time.</Paragraph>
        <Divider/>
        <Title level={4}>Still in doubt?</Title>
        <Paragraph><Link to="/faq">Learn more in our FAQs</Link> or <Link to="/support">reach out to us directly</Link>.</Paragraph>
      </div>
    </div>
  )
}

export default Home
